/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { VersionId } from "../../commons/types/VersionId";
export const Version = core.serialization.object({
    versionId: VersionId,
});
